import { BaseError } from './BaseError.js';
/**
 * Error thrown when authentication fails.
 * Used for OAuth, API key validation, token expiry, and other auth failures.
 */
export class AuthenticationError extends BaseError {
    name = 'AuthenticationError';
}
//# sourceMappingURL=AuthenticationError.js.map